import GroupSelector from '@/components/selectors/GroupSelector';
import DashboardSelectorStyles from './DashboardSelectorStyles';
import Group from '@/models/Organization/Group';
import { OrgUser } from '@/models/User/OrgUser';

/**
 * @typedef {object} DashboardGroupSelectorProps
 * @prop {Array<Group>} allGroups
 * @prop {string} currentGroup
 * @prop {OrgUser} user
 * @prop {string} orgCode
 * @prop {string} orgAzureId
 * @prop {(auth_id: string) => void} [userToHighlight]
 */

/**
 *
 * @param {DashboardGroupSelectorProps} props
 * @returns
 */

const DashboardGroupSelector = ({
  allGroups,
  currentGroup,
  user,
  orgCode,
  orgAzureId,
  userToHighlight,
}) => (
  <DashboardSelectorStyles>
    <GroupSelector
      allGroups={allGroups}
      currentGroup={currentGroup}
      user={user}
      orgCode={orgCode}
      orgAzureId={orgAzureId}
      userToHighlight={userToHighlight}
    />
  </DashboardSelectorStyles>
);

export default DashboardGroupSelector;
